import Select from "../Select";
import useContries from "./config/useContries";
import type { SelectCountriesProps } from "./SelectCountries.d";

const SelectCountries = ({
  name,
  label,
  placeholder,
  errors,
  disabled,
  register,
  helperText,
}: SelectCountriesProps) => {
  const { countries } = useContries();

  const countriesOptions = countries.map((country) => ({
    label: country.name,
    value: country.alpha2Code,
  }));

  return (
    <Select
      name={name}
      label={label}
      placeholder={placeholder}
      options={countriesOptions}
      errors={errors}
      disabled={disabled}
      register={register}
      helperText={helperText}
    />
  );
};

export default SelectCountries;
